import { render } from "./LayoutDefault.vue?vue&type=template&id=031ea0f2&bindings={\"env\":\"setup\",\"debug\":\"setup\"}"
import script from "./LayoutDefault.vue?vue&type=script&lang=ts"
export * from "./LayoutDefault.vue?vue&type=script&lang=ts"

import "./LayoutDefault.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script